$(document).ready(function(){
    var promana_uploadcontext = {
        cover: {
            viewport: {
                width:512,
                height:200,
                type:'square' 
            },
            boundary:{
                width:512,
                height:200
            },
            crop:{
                width:1536,
                height:600
            },
            default: '/images/placeholders/upload-512x200.jpg',
        },
        hero: {
            viewport: {
                width:512,
                height:80,
                type:'square' 
            },
            boundary:{
                width:512,
                height:80
            },
            crop:{
                width:2880,
                height:450
            },
            default: '/images/placeholders/upload-512x200.jpg',
        },
        profession: {
            viewport: {
                width:480,
                height:270,
                type: 'square'
            },
            boundary:{
                width:480,
                height:270
            },
            crop:{
                width:480,
                height:270
            },
            default: '/images/placeholders/upload-320x240.jpg',
        },
        thumb: {
            viewport: {
                width:200,
                height:200,
                type: 'square'
            },
            boundary:{
                width:300,
                height:300
            },
            crop:{
                width:300,
                height:300
            },
            default: '/images/placeholders/upload-300x300.jpg',
        },
        videoposter: {
            viewport: {
                width:480,
                height:270,
                type: 'square'
            },
            boundary:{
                width:480,
                height:270
            },
            crop:{
                width:960,
                height:540
            },
            default: '/images/placeholders/upload-320x240.jpg',
        },
        webposter: {
            viewport: {
                width:480,
                height:270,
                type: 'square'
            },
            boundary:{
                width:480,
                height:270
            },
            crop:{
                width:960,
                height:540
            },
            default: '/images/placeholders/upload-320x240.jpg',
        },
        invoice_logo: {
            viewport: {
                width:450,
                height:150,
                type: 'square'
            },
            boundary:{
                width:512,
                height:512/3
            },
            crop:{
                width:900,
                height:300
            },
            default: '/images/placeholders/upload-512x200.jpg',
        }
    };

    $('#image-upload').off().on('show.bs.modal',function(e){
        
        $('.crop_image').prop('disabled',true);
        $('#image_uploader').croppie('destroy');

        var context = $(e.relatedTarget).data('context');
        var mode = $(e.relatedTarget).data('mode');
        var $image_crop = $('#image_uploader').croppie({
            viewport: promana_uploadcontext[context].viewport,
            boundary: promana_uploadcontext[context].boundary,
            url: promana_uploadcontext[context].default
        });
        $('#before_crop_image').on('change', function(){
            var reader = new FileReader();
            reader.onload = function (event) {
                $image_crop.croppie('bind', {
                    url: event.target.result
                });
            }
            reader.readAsDataURL(this.files[0]);
            $('.crop_image').removeAttr('disabled');
        });
        $('.crop_image').off().on('click',function(event){
            $image_crop.croppie('result', {
                type: 'canvas',
                size: promana_uploadcontext[context].crop,
                format:'jpeg'
            }).then(function(response){
                $.ajax({
                    url:promana_uproot,  
                    type:'POST',
                    data: {
                        _token: $('meta[name="csrf-token"]').attr('content'), 
                        context: context,
                        mode: mode,
                        image: response,
                        },
                    success:function(data){
                        $('#image-upload').modal('hide');
                        switch( context ){
                            case 'thumb':
                                $('.profile-thumbnail').attr('src',data.url);
                                if(mode=='Member'){
                                    $('#sidebar-avatar').attr('src',data.url);
                                    $('#topbar-avatar').attr('src',data.url);
                                }
                                break;
                            case 'videoposter':
                                $('.profile-video-poster').attr('src',data.url);
                                break;
                            case 'webposter':
                                $('.profile-web-poster').attr('src',data.url);
                                break;
                            case 'invoice_logo':
                                $('.invoice-logo').attr('src',data.url);
                                break;
                            default:
                                $('.profile-cover')
                                    .css('background-image','url('+data.url+')')
                                    .css('background-position','50% 50%')
                                    .css('background-repeat','no-repeat')
                                    .css('background-size','cover')
                                    .css('height','21.88rem');
                        }
                    }
                })
            });
        });
    });
});  